define('modules/editor/models/content_page',['require','exports','module','./page','lib/util','../behaviours/history'],function(require, exports, module){
  "use strict";

  var Page = require("./page"),
      util = require("lib/util");

  module.exports = Page.extend({
    toJSON: function() {
      var modelParams = {
        json: Page.prototype.toJSON.apply(this),
        html: this.get("html"),
        step: this.get("step"),
        id: this.get("id")
      };
      modelParams.json.role = this.get("role");

      return modelParams;
    }
  });

  util.mixin(module.exports, require("../behaviours/history"));
});

